module.exports = __webpack_public_path__ + "static/media/calendar-2.810f06f8.svg";